export enum ActivityTypeEnum {
  Attraction = 'attraction',
  Other = 'other',
}

export enum ApecCardTypeEnum {
  New = 'new',
  Extend = 'extend',
  ChangePassport = 'change_passport',
}

export enum ApprovalItemStatusEnum {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}

export enum ApprovalVerdictActionEnum {
  Approve = 'approve',
  Reject = 'reject',
  Revert = 'revert',
}

export enum ApprovalVerdictStatusEnum {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}

export enum ApprovalableTypeEnum {
  Sale = 'Sale',
  Purchase = 'Purchase',
  Refund = 'Refund',
  Releasesale = 'ReleaseSale',
  Releasepurchase = 'ReleasePurchase',
  Accountreceivable = 'AccountReceivable',
  Accountpayable = 'AccountPayable',
  Receipt = 'Receipt',
  Transfer = 'Transfer',
  Balanceadjustment = 'BalanceAdjustment',
  Banktransaction = 'BankTransaction',
  Cashtransaction = 'CashTransaction',
  Project = 'Project',
  Tour = 'Tour',
  Orderadjustment = 'OrderAdjustment',
  Otherexpense = 'OtherExpense',
  Otherincome = 'OtherIncome',
}

export enum BalanceAdjustmentTypeEnum {
  Add = 'add',
  Subtract = 'subtract',
}

export enum BankTransactionTypeEnum {
  Debit = 'debit',
  Credit = 'credit',
}

export enum BonusPeriodStatusEnum {
  Pending = 'pending',
  Issued = 'issued',
}

export enum CalculationTypeEnum {
  Fixed = 'fixed',
  Percentage = 'percentage',
}

export enum CashTransactionTypeEnum {
  Debit = 'debit',
  Credit = 'credit',
}

export enum CategoryTypeEnum {
  Regular = 'regular',
  Vip = 'vip',
  Vvip = 'vvip',
  ArtistCelebrity = 'artist/celebrity',
}

export enum FlightCheckInStatusEnum {
  NotCheckedIn = 'not_checked_in',
  NotAvailable = 'not_available',
  SeatOk = 'seat_ok',
  CheckedIn = 'checked_in',
}

export enum HotelCheckInStatusEnum {
  NotCheckedIn = 'not_checked_in',
  NotAvailable = 'not_available',
  CheckedIn = 'checked_in',
}

export enum ChequeNoteClearingStatusEnum {
  Cleared = 'cleared',
  Rejected = 'rejected',
}

export enum ChequeNoteStatusEnum {
  Archived = 'archived',
  Pending = 'pending',
  Created = 'created',
  Cleared = 'cleared',
  Rejected = 'rejected',
  Void = 'void',
}

export enum ChequeNoteTypeEnum {
  In = 'in',
  Out = 'out',
}

export enum CommissionDepartmentEnum {
  Flight = 'flight',
  Hotel = 'hotel',
  Cruise = 'cruise',
  Document = 'document',
  Activity = 'activity',
}

export enum CommissionFilterStatusEnum {
  Active = 'active',
  Inactive = 'inactive',
  Upcoming = 'upcoming',
}

export enum CommissionTypeEnum {
  Fixed = 'fixed',
  Percentage = 'percentage',
}

export enum CustomerTypeEnum {
  Corporate = 'corporate',
  Individual = 'individual',
}

export enum DocumentSaleGuestDetailStatusEnum {
  Pending = 'pending',
  Completed = 'completed',
  Rejected = 'rejected',
}

export enum DocumentSaleStatusEnum {
  Processed = 'processed',
  Submitted = 'submitted',
  Finished = 'finished',
  Canceled = 'canceled',
  RevertToSubmittedDraft = 'revert_to_submitted_draft',
  PendingRevertToSubmittedApproval = 'pending_revert_to_submitted_approval',
  RevertToProcessedDraft = 'revert_to_processed_draft',
  PendingRevertToProcessedApproval = 'pending_revert_to_processed_approval',
}

export enum DocumentTypeEnum {
  Visa = 'visa',
  Passport = 'passport',
  Insurance = 'insurance',
  ApecCard = 'APEC',
}

export enum EmployeeGradeEnum {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
}

export enum EmployeeJobLevelEnum {
  Director = 'director',
  Manager = 'manager',
  Spv = 'spv',
  Sales = 'sales',
  NonSales = 'non-sales',
}

export enum ExpenseIncomeStatusEnum {
  Active = 'active',
  Draft = 'draft',
  Waiting = 'waiting',
  Archived = 'archived',
  PendingApproval = 'pending_approval',
  RejectedApproval = 'rejected_approval',
  VoidDraft = 'void_draft',
  PendingVoidApproval = 'pending_void_approval',
  Void = 'void',
}

export enum GenderTypeEnum {
  Male = 'male',
  Female = 'female',
}

export enum GeneralBadgeEnum {
  Processed = 'processed',
  NeedApproval = 'need_approval',
  RejectedApproval = 'rejected_approval',
  Submitted = 'submitted',
}

export enum GuestRelationTypeEnum {
  Circle = 'circle',
  MainFamily = 'main_family',
}

export enum GuestTitleTypeEnum {
  Mr = 'mr',
  Mrs = 'mrs',
  Ms = 'ms',
  Miss = 'miss',
  Mstr = 'mstr',
}

export enum InsuranceTypeEnum {
  Individual = 'individual',
  Family = 'family',
  Duo = 'duo',
  Group = 'group',
}

export enum InvoicePaymentStatusEnum {
  Pending = 'pending',
  Finished = 'finished',
  Refund = 'refund',
}

export enum MutationStatusEnum {
  Valid = 'valid',
  Void = 'void',
}

export enum NotificationTypeEnum {
  DocumentSaleReminder = 'document_sale_reminder',
  CruiseSaleReminder = 'cruise_sale_reminder',
}

export enum PassportTypeEnum {
  Regular = 'regular',
  Electronic = 'electronic',
}

export enum PaymentMethodTypeEnum {
  ChequeGiro = 'cheque_giro',
  BankTransfer = 'bank_transfer',
  Balance = 'balance',
  Cash = 'cash',
}

export enum PaymentStatusEnum {
  Active = 'active',
  Void = 'void',
}

export enum PreferenceGroupSubTypeEnum {
  Flight = 'flight',
  Hotel = 'hotel',
  Cruise = 'cruise',
  TravelDocument = 'travel_document',
  Activity = 'activity',
  Visa = 'visa',
  FlightClassBusiness = 'flight_class:business',
  FlightClassEconomy = 'flight_class:economy',
  Product = 'product',
}

export enum PreferenceGroupTypeEnum {
  Guest = 'guest',
  Booking = 'booking',
}

export enum ProductAdjustmentTypeEnum {
  Out = 'out',
  In = 'in',
}

export enum ProjectStatusEnum {
  Active = 'active',
  CancelDraft = 'cancel_draft',
  PendingCancelApproval = 'pending_cancel_approval',
  Canceled = 'canceled',
  Completed = 'completed',
}

export enum PurchaseStatusEnum {
  Archived = 'archived',
  Pending = 'pending',
  Draft = 'draft',
  VoidDraft = 'void_draft',
  Waiting = 'waiting',
  PendingApproval = 'pending_approval',
  PendingVoidApproval = 'pending_void_approval',
  RejectedApproval = 'rejected_approval',
  Completed = 'completed',
  Void = 'void',
  Refund = 'refund',
  RevertVoidDraft = 'revert_void_draft',
  PendingRevertVoidApproval = 'pending_revert_void_approval',
}

export enum PurchaseTransactionTypeEnum {
  Flight = 'flight',
  Hotel = 'hotel',
  Cruise = 'cruise',
  Document = 'document',
  Activity = 'activity',
  Product = 'product',
  Tour = 'tour',
}

export enum PurchaseTypeEnum {
  Sales = 'sales',
  Tour = 'tour',
  Product = 'product',
}

export enum ReceiptStatusEnum {
  Active = 'active',
  Completed = 'completed',
  Draft = 'draft',
  Waiting = 'waiting',
  Archived = 'archived',
  PendingApproval = 'pending_approval',
  RejectedApproval = 'rejected_approval',
  VoidDraft = 'void_draft',
  PendingVoidApproval = 'pending_void_approval',
  Void = 'void',
}

export enum RefundStatusEnum {
  Draft = 'draft',
  Waiting = 'waiting',
  Archived = 'archived',
  PendingApproval = 'pending_approval',
  RejectedApproval = 'rejected_approval',
  Processed = 'processed',
  Completed = 'completed',
  DraftCancel = 'draft_cancel',
  PendingCancel = 'pending_cancel',
  Cancel = 'cancel',
}

export enum ReleaseStatusEnum {
  Archived = 'archived',
  DraftRefund = 'draft_refund',
  PendingRefund = 'pending_refund',
  RejectRefund = 'reject_refund',
  DraftCancelRefund = 'draft_cancel_refund',
  PendingCancelRefund = 'pending_cancel_refund',
  CancelRefund = 'cancel_refund',
  Draft = 'draft',
  Requested = 'requested',
  Waiting = 'waiting',
  PendingApproval = 'pending_approval',
  RejectedApproval = 'rejected_approval',
  PendingReleaseApproval = 'pending_release_approval',
  RejectedReleaseApproval = 'rejected_release_approval',
  Completed = 'completed',
}

export enum ReligionEnum {
  Muslim = 'muslim',
  Protestant = 'protestant',
  Catholic = 'catholic',
  Hindu = 'hindu',
  Buddhist = 'buddhist',
  Confucian = 'confucian',
  Other = 'other',
}

export enum SaleDepartmentEnum {
  Flight = 'flight',
  Hotel = 'hotel',
  Cruise = 'cruise',
  Document = 'document',
  Activity = 'activity',
  Product = 'product',
}

export enum SaleProjectStatusEnum {
  None = 'none',
  DraftRemoval = 'draft_removal',
  PendingRemoval = 'pending_removal',
}

export enum SalePurchaseGuestStatusEnum {
  Active = 'active',
  Rescheduling = 'rescheduling',
  Rescheduled = 'rescheduled',
  RejectedReschedule = 'rejected_reschedule',
  RefundedRefunding = 'refunded_refunding',
  Refunding = 'refunding',
  Refunded = 'refunded',
}

export enum SaleStatusEnum {
  Active = 'active',
  Draft = 'draft',
  Waiting = 'waiting',
  Archived = 'archived',
  Processed = 'processed',
  Submitted = 'submitted',
  PendingApproval = 'pending_approval',
  RejectedApproval = 'rejected_approval',
  OpenTicket = 'open_ticket',
  RescheduleDraft = 'reschedule_draft',
  Rescheduling = 'rescheduling',
  Rescheduled = 'rescheduled',
  PendingRescheduleApproval = 'pending_reschedule_approval',
  RejectedRescheduleApproval = 'rejected_reschedule_approval',
  VoidDraft = 'void_draft',
  PendingVoidApproval = 'pending_void_approval',
  Void = 'void',
  Completed = 'completed',
  Refund = 'refund',
  RevertVoidDraft = 'revert_void_draft',
  PendingRevertVoidApproval = 'pending_revert_void_approval',
}

export enum SaleTransactionTypeEnum {
  Flight = 'flight',
  Hotel = 'hotel',
  Cruise = 'cruise',
  Document = 'document',
  Activity = 'activity',
  Product = 'product',
  Tour = 'tour',
}

export enum TitleTypeEnum {
  Mr = 'mr',
  Mrs = 'mrs',
  Cv = 'cv',
  Pt = 'pt',
  Ms = 'ms',
  Miss = 'miss',
  Mstr = 'mstr',
}

export enum TourBedTypeEnum {
  Single = 'single',
  Twin = 'twin',
  King = 'king',
  Queen = 'queen',
  Double = 'double',
}

export enum TourFlightHotelStatusEnum {
  Active = 'active',
  Draft = 'draft',
  Waiting = 'waiting',
  Archived = 'archived',
  PendingApproval = 'pending_approval',
  RejectedApproval = 'rejected_approval',
}

export enum TourStatusEnum {
  Draft = 'draft',
  Archived = 'archived',
  Waiting = 'waiting',
  PendingApproval = 'pending_approval',
  RejectedApproval = 'rejected_approval',
  Active = 'active',
  CancelDraft = 'cancel_draft',
  PendingCancelApproval = 'pending_cancel_approval',
  Canceled = 'canceled',
  CloseDraft = 'close_draft',
  PendingCloseApproval = 'pending_close_approval',
  Closed = 'closed',
  RevertCloseDraft = 'revert_close_draft',
  PendingRevertCloseApproval = 'pending_revert_close_approval',
}

export enum TourTypeEnum {
  Private = 'private',
  Series = 'series',
}

export enum TransactionEmployeeTypeEnum {
  Operator = 'operator',
  Sales = 'sales',
  Lead = 'lead',
}

export enum TransactionalBadgeEnum {
  Active = 'active',
  NeedApproval = 'need_approval',
  RejectedApproval = 'rejected_approval',
  Void = 'void',
}

export enum TransactionalStatusEnum {
  Active = 'active',
  VoidDraft = 'void_draft',
  PendingVoidApproval = 'pending_void_approval',
  Void = 'void',
  Draft = 'draft',
  Waiting = 'waiting',
  Archived = 'archived',
  PendingApproval = 'pending_approval',
  RejectedApproval = 'rejected_approval',
  Completed = 'completed',
}

export enum TransferAccountTypeEnum {
  Bank = 'bank',
  Cash = 'cash',
}

export enum UserStatusEnum {
  Safe = 'safe',
  UnderSurveillance = 'under_surveillance',
}

export enum EnumList {
  ActivityType = 'ActivityType',
  ApecCardType = 'ApecCardType',
  ApprovalItemStatus = 'ApprovalItemStatus',
  ApprovalVerdictAction = 'ApprovalVerdictAction',
  ApprovalVerdictStatus = 'ApprovalVerdictStatus',
  ApprovalableType = 'ApprovalableType',
  BalanceAdjustmentType = 'BalanceAdjustmentType',
  BankTransactionType = 'BankTransactionType',
  BonusPeriodStatus = 'BonusPeriodStatus',
  CalculationType = 'CalculationType',
  CashTransactionType = 'CashTransactionType',
  CategoryType = 'CategoryType',
  ChequeNoteClearingStatus = 'ChequeNoteClearingStatus',
  ChequeNoteStatus = 'ChequeNoteStatus',
  ChequeNoteType = 'ChequeNoteType',
  CommissionDepartment = 'CommissionDepartment',
  CommissionFilterStatus = 'CommissionFilterStatus',
  CommissionType = 'CommissionType',
  CustomerType = 'CustomerType',
  DocumentSaleGuestDetailStatus = 'DocumentSaleGuestDetailStatus',
  DocumentSaleStatus = 'DocumentSaleStatus',
  DocumentType = 'DocumentType',
  EmployeeGrade = 'EmployeeGrade',
  EmployeeJobLevel = 'EmployeeJobLevel',
  ExpenseIncomeStatus = 'ExpenseIncomeStatus',
  FlightCheckInStatus = 'FlightCheckInStatus',
  GenderType = 'GenderType',
  GeneralBadge = 'GeneralBadge',
  GuestRelationType = 'GuestRelationType',
  GuestTitleType = 'GuestTitleType',
  HotelCheckInStatus = 'HotelCheckInStatus',
  InsuranceType = 'InsuranceType',
  InvoicePaymentStatus = 'InvoicePaymentStatus',
  MutationStatus = 'MutationStatus',
  NotificationType = 'NotificationType',
  PassportType = 'PassportType',
  PaymentMethodType = 'PaymentMethodType',
  PaymentStatus = 'PaymentStatus',
  PreferenceGroupSubType = 'PreferenceGroupSubType',
  PreferenceGroupType = 'PreferenceGroupType',
  ProductAdjustmentType = 'ProductAdjustmentType',
  ProjectStatus = 'ProjectStatus',
  PurchaseStatus = 'PurchaseStatus',
  PurchaseTransactionType = 'PurchaseTransactionType',
  PurchaseType = 'PurchaseType',
  ReceiptStatus = 'ReceiptStatus',
  RefundStatus = 'RefundStatus',
  ReleaseStatus = 'ReleaseStatus',
  Religion = 'Religion',
  SaleDepartment = 'SaleDepartment',
  SaleProjectStatus = 'SaleProjectStatus',
  SalePurchaseGuestStatus = 'SalePurchaseGuestStatus',
  SaleStatus = 'SaleStatus',
  SaleTransactionType = 'SaleTransactionType',
  TitleType = 'TitleType',
  TourBedType = 'TourBedType',
  TourFlightHotelStatus = 'TourFlightHotelStatus',
  TourStatus = 'TourStatus',
  TourType = 'TourType',
  TransactionEmployeeType = 'TransactionEmployeeType',
  TransactionalBadge = 'TransactionalBadge',
  TransactionalStatus = 'TransactionalStatus',
  TransferAccountType = 'TransferAccountType',
  UserStatus = 'UserStatus',
}
